import React, { FC, useMemo } from 'react';

import IconLocation from 'material-react-icons/LocationOn';

import useTranslate from '../../hooks/useTranslate';
import getGolfClubInfo from '../../services/apis/golfCourses/getGolfClubInfo';
import { GolfClubPromotion } from '../../services/apis/golfCourses/types';
import { MappedGolfCourseType } from '../../services/apis/golfCourses/types';
import useStore from '../../store/useStore';
import ExpandableText from '../ExpandableText/ExpandableText';
import GolfCourseBadge from '../GolfCourseBadge/GolfCourseBadge';
import RatingBox from '../GolfCourses/RatingBox';
import SanitizeHTML from '../SanitizeHTML/SanitizeHTML';

interface GolfClubInfoProps {
  golfCourse: MappedGolfCourseType;
}

const DESCRIPTION_CLAMP = 4;

const GolfClubInfo: FC<GolfClubInfoProps> = ({ golfCourse }) => {
  const { translate } = useTranslate();
  const golfCourseInfo = useMemo(() => getGolfClubInfo(golfCourse), [golfCourse]);
  const isGolfhaftetRequest = useStore(state => state.isGolfhaftetRequest);

  const badgeInfo = useMemo(
    () => ({
      promoted: golfCourse.promotion === GolfClubPromotion.Promoted,
      recommended: golfCourse.promotion === GolfClubPromotion.Recommended,
      discount: !!golfCourse.golfCourse.campaignPercentage,
      discountValue: golfCourse.golfCourse.campaignPercentage,
    }),
    [golfCourse.promotion, golfCourse.golfCourse.campaignPercentage]
  );

  return (
    <div className="pb-3 mt-1 mt-sm-3">
      <div className="d-flex align-items-center">
        <h1 className="fw-bold mb-0 ">{golfCourseInfo?.h1 || golfCourse.golfClub.name}</h1>
        {badgeInfo.discount && !isGolfhaftetRequest && (
          <div className="ms-2">
            <GolfCourseBadge {...badgeInfo} />
          </div>
        )}
      </div>
      <h2>
        {golfCourseInfo?.h2 || golfCourse.golfCourse.name}{' '}
        {golfCourse.distance ? `(${Math.round(golfCourse.distance)} km)` : ''}
      </h2>

      <RatingBox course={golfCourse} className="mb-3" />
      {!!golfCourseInfo?.address && (
        <div className="d-flex gap-2 align-items-end mb-3">
          <IconLocation color="#84a13d" size={20} className="align-self-center" />
          <span>{golfCourseInfo?.address}</span>
        </div>
      )}
      <div>
        {golfCourseInfo?.description ? (
          <ExpandableText
            text={<SanitizeHTML>{golfCourseInfo.description}</SanitizeHTML>}
            clamp={DESCRIPTION_CLAMP}
          />
        ) : (
          translate('default.CourseDescriptionMissing')
        )}
      </div>
    </div>
  );
};

export default GolfClubInfo;
